<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Integrations</h2>

    <div class="card-holder">
      <p class="caption">
        Integrate with Apps to track sales, marketing, ROI and more.
      </p>

      <!-- Available Integrations Here -->
      <section class="section-holder">
        <SalesforceIntegration />

        <!-- <IntegrationList :integrations="integrations" /> -->
        <!-- <SalesforceIntegration v-if="!hasProvider('salesforce')" /> -->
      </section>
    </div>
  </div>
</template>

<script>
import { layouts } from '../helpers'
import SalesforceIntegration from '@/components/Integrations/SalesforceIntegration'

export default {
  name: 'IntegrationsMain',
  components: {
    SalesforceIntegration
  },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    this.$store.dispatch(
      'integration/getIntegrationsListForUser',
      this.$store.state.profile.user.id
    )
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.card-holder {
  padding: 2.5rem 3.5rem;
  background: inherit;
  border: 1px solid $onyx;
  border-radius: 29px;

  .caption {
    font-size: 0.813rem;
    font-family: $inter;
    font-weight: 700;
    text-align: left;
  }

  .section-holder {
    margin-top: 2rem;
  }
}
</style>
